var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
  id: "eu_svg__d"
}, /*#__PURE__*/React.createElement("g", {
  id: "eu_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  id: "eu_svg__a",
  d: "m0-1-.31.95.477.156z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__a",
  transform: "scale(-1 1)"
})), /*#__PURE__*/React.createElement("g", {
  id: "eu_svg__c"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__b",
  transform: "rotate(72)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__b",
  transform: "rotate(144)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__c",
  transform: "scale(-1 1)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#039",
  d: "M0 0h512v512H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fc0",
  transform: "translate(256 258.414)scale(25.28395)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__d",
  width: "100%",
  height: "100%",
  y: -6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__d",
  width: "100%",
  height: "100%",
  y: 6
}), /*#__PURE__*/React.createElement("g", {
  id: "eu_svg__e"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__d",
  width: "100%",
  height: "100%",
  x: -6
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(-144 -2.344 -2.11)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(144 -2.11 -2.344)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(72 -4.663 -2.076)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__d",
  width: "100%",
  height: "100%",
  transform: "rotate(72 -5.076 .534)"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#eu_svg__e",
  width: "100%",
  height: "100%",
  transform: "scale(-1 1)"
}))));
export default SvgEu;